<template>
  <div class="blog-entry-container pt-2">
    <b-container class="inner-container">
      <b-row>
        <b-col class="mb-5">
          <router-link :to="{ name: 'Blog' }">
            <i class="pe-7s-angle-left"></i> <span>Back to Blog</span>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          offset-sm="0"
          sm="12"
          offset-md="0"
          md="12"
          offset-lg="1"
          lg="10"
          offset-xl="1"
          xl="10"
        >
          <component :is="selectedPost" :post="postData" />

          <p class="footer-note">
            <em
              >Get started building your own capsules at
              <router-link class="home-link" :to="{ name: 'Blog' }">
                <strong>Unstitched.xyz</strong>
              </router-link>
              and if you enjoyed this post, please share it! ❤️</em
            >
          </p>

          <hr />
          Connect:
          <ConnectButtons class="mb-4" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ENTRIES from "@/components/blog/entries.json";
import TravelInStyleThisSummerWithOurJulyCapsuleWardrobe from "@/components/blogEntry/posts/travel-in-style-this-summer-with-our-july-capsule-wardrobe.vue";
import UltimateCapsuleWardrobeGuide from "@/components/blogEntry/posts/ultimate-capsule-wardrobe-guide.vue";
import ConnectButtons from "@/components/blogEntry/ConnectButtons.vue";

export default {
  components: {
    ENTRIES,
    ConnectButtons,
    TravelInStyleThisSummerWithOurJulyCapsuleWardrobe,
    UltimateCapsuleWardrobeGuide
  },

  mounted() {
    window.analytics.page(`Blog: ${this.$route.params.slug}`);
  },

  computed: {
    selectedPost() {
      return this.$lodash.upperFirst(
        this.$lodash.camelCase(this.$route.params.slug)
      );
    },
    postData() {
      return this.$lodash.find(ENTRIES["posts"], [
        "slug",
        this.$route.params.slug
      ]);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";
@import url("https://fonts.googleapis.com/css?family=Josefin+Sans:300,400,700&display=swap");

.blog-entry-container /deep/ {
  font-family: "Josefin Sans", arial, sans-serif;
  font-weight: 300;
  font-size: 20px;
  line-height: 1.9;
  color: #6c757d;

  .footer-note {
    font-size: 24px;
    padding-top: 80px;
    padding-bottom: 80px;
  }

  .inner-container {
    padding-right: 0;
    padding-left: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6 {
    color: #000;
    font-family: "Josefin Sans", arial, sans-serif;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
  }

  h2 {
    padding-top: 30px;
  }

  h5 {
    padding-top: 1rem;
  }
  .badge {
    font-weight: 500;
    letter-spacing: 1px;
  }

  .home-link,
  .blog-link {
    transition: 0.3s all ease;
    text-decoration: none;
    color: #6c757d;

    &:hover {
      text-decoration: none;
      color: darken($primary-accent, 10%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/BlogEntry.vue